import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'src/constants/paths';

import { Wrapper } from './AddAssemblyPage.styled';
import { SelectLayoutForm } from './modules/selectLayoutForm/SelectLayoutForm';
import { SelectLayoutType } from './modules/selectLayoutType/SelectLayoutType';

export const AddAssemblyPage = () => {
  const [layoutTypeId, setLayoutTypeId] = React.useState(0);
  const [active, setActive] = React.useState('');

  const navigate = useNavigate();

  return (
    <Wrapper>
      {layoutTypeId === 0 || active === 'layoutType' ? (
        <SelectLayoutType
          onClose={() => {
            navigate({
              pathname: PATHS.ASSEMBLIES,
            });
          }}
          setLayoutTypeId={setLayoutTypeId}
          setActive={setActive}
        />
      ) : (
        <SelectLayoutForm layoutTypeId={layoutTypeId} setActive={setActive} />
      )}
    </Wrapper>
  );
};
